import * as React from 'react';
var isHmr = false;
export var getIsHmr = function () { return isHmr; };
export var startHmr = function () {
    if (!isHmr) {
        isHmr = true;
        if (process.env.NODE_ENV === 'development') {
            console.log('HMR Starting...');
        }
    }
};
export var stopHmr = function () {
    if (isHmr) {
        isHmr = false;
        if (process.env.NODE_ENV === 'development') {
            console.log('HMR Done');
        }
    }
};
export function Hmr(_a) {
    var children = _a.children;
    React.useEffect(function () {
        setTimeout(function () {
            stopHmr();
        });
    }, []);
    return React.createElement(React.Fragment, null, children);
}
//# sourceMappingURL=onHmr.js.map